module.exports = __webpack_public_path__ + "static/media/6a42254612117e1cf47fc37e926c0cbe02a09db352700-2zp9bf.66c68f7d.jpeg";